module.exports = __webpack_public_path__ + "4a6191c0aae5c213f071d11d605ec8e2.jpg";